export const BulletBankStyle = {
  baseStyle: {},
  variants: {
    wrapper: {
      jobInfoFlex: {
        flexDirection: ['column', null, null, 'row'],
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingBottom: '16px',
        paddingLeft: ['32px', null, 0],
      },
      unselectedWrapper: {
        // height: '100%',
        border: '1px solid',
        borderColor: 'GRAY_2',
        borderRadius: '4px',
        backgroundColor: 'GRAY_LIGHT',
        overflowY: 'hidden',
        // margin: 0,
      },
      unselectedItemsContainer: {
        maxHeight: '400px',
        padding: '16px',
        backgroundColor: 'transparent',
        borderRadius: '0 0 4px 4px',
        overflowY: 'scroll',
        scrollBehaviour: 'smooth',
        borderTop: '1px solid',
        borderColor: 'GRAY_2',
      },
      selectedItem: {
        border: '1px solid',
        borderColor: 'GRAY_2',
        borderRadius: '4px',
        padding: ['0 0 0 16px', null, '0 0 0 8px', '0 0 0 16px'],
        margin: '8px 0',
      },
      selectedLabelBox: {
        flexGrow: 1,
        padding: [
          '16px 0 16px 16px',
          null,
          '16px 0 16px 8px',
          '16px 0 16px 16px',
        ],
      },
      unselectedRegen: {
        backgroundColor: '#E9FDE0',
        color: '#fff',
      },
      unselectedItem: {
        border: '1px solid',
        borderColor: 'GRAY_2',
        borderRadius: '4px',
        backgroundColor: 'white',
        padding: '0 0 0 16px',
        margin: '8px 0',
      },
      unselectedLabelBox: {
        flexGrow: 1,
        padding: '16px 0',
      },
      navContainer: {
        width: '100%',
        padding: '0 16px 16px 16px',
        background: 'WHITE',
        borderRadius: '4px 4px 0 0',
        /*
        display: 'flex',
        justifyContent: 'space-between',

         */
      },
      searchContainer: {
        width: '100%',
        padding: '16px 16px 0 16px',
        background: 'WHITE',
        borderRadius: '4px 4px 0 0',
      },
    },
  },
};
